import { render, staticRenderFns } from "./MyCoupons.vue?vue&type=template&id=4adf54ff&scoped=true"
import script from "./MyCoupons.vue?vue&type=script&lang=js"
export * from "./MyCoupons.vue?vue&type=script&lang=js"
import style0 from "./MyCoupons.vue?vue&type=style&index=0&id=4adf54ff&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf54ff",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\business\\yoyotravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4adf54ff')) {
      api.createRecord('4adf54ff', component.options)
    } else {
      api.reload('4adf54ff', component.options)
    }
    module.hot.accept("./MyCoupons.vue?vue&type=template&id=4adf54ff&scoped=true", function () {
      api.rerender('4adf54ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mine/MyCoupons.vue"
export default component.exports